import { render, staticRenderFns } from "./ActionUpgrade.vue?vue&type=template&id=f0128700&scoped=true&"
import script from "./ActionUpgrade.vue?vue&type=script&lang=js&"
export * from "./ActionUpgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0128700",
  null
  
)

export default component.exports